import { IconButton } from "@mui/material";
import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { TDrawerCloseFunction } from "@ryde/shared";

interface IDrawerCloseIconButtonProps {
  onCloseDrawer: TDrawerCloseFunction;
}

export const DrawerCloseIconButton: FC<IDrawerCloseIconButtonProps> = ({
  onCloseDrawer,
}) => {
  return (
    <IconButton className="DrawerCloseIconButton" onClick={onCloseDrawer}>
      <SVG_MUI.XMarkSVG style={{ height: 15, width: 15 }} />
    </IconButton>
  );
};
